<template>
	<div class="check-contenido">
		<p  class="check-titular"> 
			<span>
				{{titulo}}
			</span>
			<span class="span-info">
				<BotonInfoTooltip 
					v-if="texto_info"
					:contenido="texto_info"
				/>
			</span>
			
		</p>
		<button @click="quitarPonerTodos" class="btn-todos">{{ quitar_poner_todos }}</button>
		<p v-html="descripcion" class="check-descripcion"></p>
		<div class="check-contenedor-checkbox">
			<label class="checkbox" v-for="opcion in opciones" :key="opcion.id">
				<input type="checkbox" :value="opcion.id" v-model="checkeados">  
				<span>{{opcion.texto}}</span>
			</label>
		</div>
	</div>
</template>

<script>
import BotonInfoTooltip from "@/components/utils/BotonInfoTooltip.vue";

export default {
  name: 'CheckGeneral',
	props: {
		titulo: String,
		descripcion: String,
		opciones: Array,
		variable_store: String,
		funcion_store: String,
		texto_info: String
	},
	components:{
		BotonInfoTooltip
	},
	data(){
		return {
			quitar_poner_todos: "Quitar todos"
		}
	},
	mounted: function() {
		this.checkeados = this.opciones.map((d) => d.id)
	},
	methods: {
		quitarPonerTodos() {
			if(this.quitar_poner_todos == "Quitar todos"){
				this.quitar_poner_todos = "Poner todos";
				this.checkeados = []
			}
			else{
				this.quitar_poner_todos = "Quitar todos";
				this.checkeados = this.opciones.map((d) => d.id)
			}
		},
	},
	computed: {
		checkeados: {
			get() {
				return this.$store.state[this.variable_store]
			},
			set(value) {
				this.$store.commit(this.funcion_store, value);
			}
		}
	},	
}
</script>

<style scoped lang="scss">
$padding: $gap * .5;

.check-contenido {
	flex: 1;
	font-size: 14px;
	display: flex;
	flex-direction: column;
	padding: $padding*.5 $padding;

	// max-width: 290px;
	.check-titular{
		display: inline-flex;
		span.span-info{
			margin-top: -5px;
			margin-left: auto;
		}
		
	}
}
.btn-todos {
	background: #fff;
	border: 1px solid #000;
	color: #000;
	font-size: 12px;
	padding: 0 5px;
	margin: 0 auto 0 0;
	position:relative;
	max-width: 120px;
	float: right;
	transition: background-color .3s ease-in-out, color .3s ease-in-out;
	&:hover,
	&:focus {
		background: #000;
		color: #fff;
	}
}

.check-descripcion {
	font-size: 14px;
	margin: 0;
	flex: 1;
	margin: 0 0 5px;
}
.check-contenedor-checkbox {
	display: flex;
	
}
label.checkbox {
	display: block;
	flex: 1 0;
	margin: 5px 5px 0 0;
	input {
		margin: auto;
		display: block;
	}
	span {
		font-size: 12px;
		display: block;
		white-space: nowrap;
		text-align: center;
	}
}
</style>
